import React, { useCallback } from 'react';
import { useBookingLimit, usePracticeBookingLimit } from 'hooks/marketing/useBookingLimit';
import MyLimits from './MyLimits';
import PracticeLimits from './PracticeLimits';

interface Props {
    /** 当前处于 Practice View 还是 My Marketing —— 由外层 KlarityMarketing 的视角切换决定 */
    isPracticeView: boolean;
    /** 当前用户是否在 group practice 里（session 信息，不是接口） */
    isGroupPractice: boolean;
}

/**
 * Patient limits —— Marketing 下的第三个 chip。
 *
 * **两个视图编辑的是同一份 practice 级数据**，只是展示范围不同：
 * Practice View 看全员，My Marketing 看自己。因此任一处保存后，
 * 另一处的数据即失效，这里统一刷新两份，避免用户切回去看到旧数字。
 */
const PatientLimits: React.FC<Props> = ({ isPracticeView, isGroupPractice }) => {
    const [mine, mineLoading, refetchMine] = useBookingLimit();
    // 非 owner/admin 拉 practice 级数据会 4003；能看到 Practice View 就等于有权
    const [practice, practiceLoading, refetchPractice] = usePracticeBookingLimit(isPracticeView);

    const refetchAll = useCallback(() => {
        refetchMine();
        if (isPracticeView) {
            refetchPractice();
        }
    }, [refetchMine, refetchPractice, isPracticeView]);

    if (isPracticeView) {
        return (
            <PracticeLimits data={practice} loading={practiceLoading} refetch={refetchAll} />
        );
    }

    return (
        <MyLimits
            data={mine}
            loading={mineLoading}
            refetch={refetchAll}
            isGroupPractice={isGroupPractice}
        />
    );
};

export default PatientLimits;
